import React, { Component } from "react";
import { CardActions, CardContent } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";

const StepCelesteContainer = styled.div`
  height: auto;
  @media only screen and (min-width: 768px) {
    margin-top: 20px;
  }
`;

const StepList = styled.ol`
  list-style: none;
  padding-left: 0;
`;

const StepItem = styled.li`
  counter-increment: custom;
  &:first-child {
    counter-reset: custom;
  }
  &:before {
    content: counter(custom) ") ";
  }
`;

const styles = theme => ({});

class StepCeleste extends Component {
  render() {
    return (
      <StepCelesteContainer>
        <Card>
          <CardContent>
            <Typography
              variant={"subtitle2"}
              gutterBottom
              align={"center"}
              style={{ marginBottom: "10px" }}
            >
              Testez votre éligibilité
            </Typography>
            <Typography component="div">
              <StepList>
                <StepItem>
                  Indiquez votre adresse ou votre numéro de téléphone dans le
                  moteur de recherche.
                  <br />
                </StepItem>
                <StepItem>
                  Accédez aux offres Fibres, Mobile 4G et Cuivre disponibles à
                  votre adresse.
                  <br />
                </StepItem>
                <StepItem>
                  Effectuez une demande de devis ou d'informations.
                  <br />
                </StepItem>
              </StepList>
            </Typography>
          </CardContent>
          <CardActions style={{ justifyContent: "center" }}>
            <Button
              style={{ backgroundColor: "#a863a5", color: "white" }}
              href={"https://www.celeste.fr/contact"}
              target={"_blank"}
            >
              Contactez-nous
            </Button>
          </CardActions>
        </Card>
      </StepCelesteContainer>
    );
  }
}

export default withStyles(styles, { withTheme: true })(StepCeleste);
